/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import styled from 'styled-components';
import { Box } from 'grommet';
import { BrandColors } from '@blend/enterprise-components';

export const OuterContainer = styled(Box)`
  background-color: ${BrandColors.NIGHT_90};
  height: 100vh;
  overflow: auto;
  width: 100vw;
`;

export const MiddleContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
`;

export const InnerContainer = styled(Box)`
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 42px 0;
  width: 480;
`;

export const HeaderEl = styled(Box)`
  margin-bottom: 24px;
`;
